<ng-container *ngIf="!(isLoading$ | async); else isLoadingSpinner">
  <div class="table-responsive">
    <table
      class="table table-bordered table-hover w-auto bg-white"
      data-test-id="organize-bookings-table"
    >
      <thead>
        <tr>
          <th scope="col" class="cursor-pointer text-primary text-nowrap"
            ><a href="javascript:;" (click)="onHeaderClick('rooms')">
              {{ 'bookingModule.rooms' | translate }}
              <i
                class="fas fa-sort"
                [ngClass]="{
                  sorting_field:
                    activeSortingField == 'rooms_asc' ||
                    activeSortingField == 'rooms_desc'
                }"
                role="img"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              ></i>
            </a>
          </th>
          <th scope="col" class="cursor-pointer text-primary text-nowrap">
            <a href="javascript:;" (click)="onHeaderClick('size')">
              {{ 'general.size' | translate }}
              <i
                class="fas fa-sort"
                [ngClass]="{
                  sorting_field:
                    activeSortingField == 'size_asc' ||
                    activeSortingField == 'size_desc'
                }"
                role="img"
                attr.aria-label="{{ 'wcag.sort' | translate }}"
              ></i>
            </a>
          </th>
          <th scope="col" *ngFor="let date of datesToShow">
            {{ date | date : 'EEE d MM' : null : (selectedLanguage$ | async) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="stick-to-top bg-white" data-test-id="organize-bookings-summary-row-top">
          <td colspan="2"></td>
          <td
            *ngFor="let date of datesToShow"
            data-test-id="organize-bookings-summary-cell-top"
          >
            <ng-container
              *ngIf="
                (getNumberOfMyOriginalParticipationsByDate$(date) | async) > 0
              "
            >
              <span>
                {{ getNumberOfMyCurrentParticipationsByDate(date) }}/{{
                  getNumberOfMyOriginalParticipationsByDate$(date) | async
                }}
              </span>
              <span
                *ngIf="
                  getNumberOfMyCurrentParticipationsByDate(date) ==
                    (getNumberOfMyOriginalParticipationsByDate$(date) | async);
                  else incorrectParticipantNumber
                "
                class="total-column-icon check-icon"
              >
                <i
                  role="img"
                  class="fas fa-check-circle text-success"
                  attr.aria-label="{{ 'alert.success' | translate }}"
                ></i>
              </span>
              <ng-template #incorrectParticipantNumber>
                <span role="alert" aria-atomic="true"
                  ><i
                    role="img"
                    class="fas fa-exclamation-circle text-warning"
                    attr.aria-label="{{ 'alert.warning' | translate }}"
                  ></i
                ></span>
              </ng-template>
            </ng-container>
          </td>
        </tr>
        <tr
          *ngFor="let product of productsInSelectedGroup$ | async"
          data-test-id="organize-bookings-room-row"
        >
          <td data-test-id="organize-bookings-room-name">
            {{ product.description }}
          </td>
          <td data-test-id="organize-bookings-room-size">
            {{ product.maxParticipants }}
          </td>
          <td
            data-test-id="organize-bookings-room-cell"
            class="data-cell"
            [ngClass]="{
              'cell-booked bg-success text-dark': isCellBooked(product, date),
              'cell-occupied bg-danger':
                isCellOccupied(product, date) && !isCellBooked(product, date),
              'cell-unavailable  bg-soft-dark bg-stripes-svg':
                isCellUnavailable(product, date)
            }"
            *ngFor="let date of datesToShow"
            (click)="onCellClick(product, date)"
            (keyup.enter)="onCellClick(product, date)"
            tabindex="0"
            role="link"
          >
            {{ getNumberOfParticipantsForResource(product, date) || '' }}
          </td>
        </tr>
        <tr
          class="bg-white stick-to-bottom"
          data-test-id="organize-bookings-summary-row-bottom"
        >
          <td colspan="2"></td>
          <td
            *ngFor="let date of datesToShow"
            data-test-id="organize-bookings-summary-cell-bottom"
          >
            <ng-container
              *ngIf="
                (getNumberOfMyOriginalParticipationsByDate$(date) | async) > 0
              "
            >
              <span>
                {{ getNumberOfMyCurrentParticipationsByDate(date) }}/{{
                  getNumberOfMyOriginalParticipationsByDate$(date) | async
                }}
              </span>
              <span
                *ngIf="
                  getNumberOfMyCurrentParticipationsByDate(date) ==
                    (getNumberOfMyOriginalParticipationsByDate$(date) | async);
                  else incorrectParticipantNumber
                "
                class="total-column-icon check-icon"
              >
                <i
                  role="img"
                  class="fas fa-check-circle text-success"
                  attr.aria-label="{{ 'alert.success' | translate }}"
                ></i>
              </span>
              <ng-template #incorrectParticipantNumber>
                <span
                  ><i
                    role="img"
                    class="fas fa-exclamation-circle text-warning"
                    attr.aria-label="{{ 'alert.warning' | translate }}"
                  ></i
                ></span>
              </ng-template>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<ng-template #isLoadingSpinner>
  <div
    class="spinner-border"
    role="status"
    attr.aria-label="{{ 'general.loading' | translate }}"
  >
  </div>
</ng-template>
